import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import moment from "moment";
import { debounceTime, fromEvent, map, Observable, retry } from "rxjs";
import { Blog } from "../model/blog.model";

@Injectable({
  providedIn: "root",
})
export class BlogService {
  private apiBlogUrl = "/blogs";
  private apiBlogCateUrl = "/blog_categories";

  #http = inject(HttpClient);

  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null),
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }

  getBlogs(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http.get<any>(`${this.apiBlogUrl}?${params}`).pipe(retry(1));
  }
  getBlog(id: number) {
    return this.#http.get<any>(`${this.apiBlogUrl}/${id}`).pipe(retry(1));
  }

  getBlogCategories(filter?: any) {
    const params = this._setParams(filter) || "";
    return this.#http
      .get<any>(`${this.apiBlogCateUrl}?${params}`)
      .pipe(retry(1));
  }

  getYoutubeThumbnail(oembedUrl: string): string | null {
    const regex = /youtu\.be\/([a-zA-Z0-9_-]+)/;
    const match = oembedUrl?.match(regex);
    if (match) {
      return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`; // maxresdefault | hqdefault | mqdefault | default
    }
    return null;
  }

  mapImageInnerHtml(blog_data: Blog[]): Blog[] {
    let blogMap = blog_data.map((item: Blog) => {
      if (!item.article) return;
      const imagePaths = item.article;
      const parser = new DOMParser();
      const doc = parser.parseFromString(imagePaths, "text/html");
      let blog_img = null;
      const elements = Array.from(doc.querySelectorAll("img, oembed"));
      for (const element of elements) {
        if (element.tagName.toLowerCase() === "img") {
          blog_img = element.getAttribute("src");
          break;
        } else if (element.tagName.toLowerCase() === "oembed") {
          const oembedUrl = element.getAttribute("url");
          const youtubeThumbnail = this.getYoutubeThumbnail(
            oembedUrl as string,
          );
          if (youtubeThumbnail) {
            blog_img = youtubeThumbnail;
            break;
          }
        }
      }
      return {
        ...item,
        blog_img,
        is_today: moment(item.created_at).isSame(moment(), "day"),
      } as Blog;
    });
    return blogMap as Blog[];
  }
}
